module.exports = __webpack_public_path__ + "media/kojic-small.8a423efb.mp4";